export const CLOSED_ACTION_ITEM_RETENTION_DAYS = 120;

export function closedActionItemExpiry(closedAt: Date): Date {
	return new Date(
		closedAt.getTime() +
			CLOSED_ACTION_ITEM_RETENTION_DAYS * 24 * 60 * 60 * 1000,
	);
}
